import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {ToastrService} from 'ngx-toastr';
import {catchError, switchMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {DownloadCsv} from '../../../../shared/modules/export/store/actions/download-csv.actions';
import {ExportAccountsFailure, ExportAccountsSuccess, ExportActionTypes} from '../actions/export.actions';
import {AccountsService} from '../../services/accounts/accounts.service';

const noDataMessage = 'Unfortunately there is no data to export';

@Injectable()
export class ExportEffects {
    exportAccounts$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ExportActionTypes.exportAccounts),
            switchMap((action: { fields: string[] }) => {
                return this.accountsService
                    .downloadAccountsCsv(action.fields)
                    .pipe(
                        switchMap((res) => {
                            if (res.body.size === 0) {
                                this.toastService.error(noDataMessage);
                                return of(ExportAccountsFailure(new Error(noDataMessage))); ;
                            }
                            return [
                                DownloadCsv({ blob: res }),
                                ExportAccountsSuccess({ res })
                            ]
                        }),
                        catchError((error: any) => {
                            this.toastService.error('Exported failed');
                            return of(ExportAccountsFailure(error));
                        })
                    );
            })
        )
    );

    constructor(
        private actions$: Actions,
        private accountsService: AccountsService,
        private toastService: ToastrService,
    ) { }
}
